import { MutableRefObject } from 'react';
import { useMapInstance } from '@/utils/context/mapInstanceContext';
import { Point } from '@/types/map';
import { useDiagramPreviewMap } from '@/components/FunctionalArea/Modal/DiagramPreview/useDiagramPreviewMap';
import { useOlElementPreviewView } from '@/components/FunctionalArea/Modal/EditElementModal/utils/useOlElementPreviewView';

interface UseElementDiagramPreviewResult {
  targetRef: MutableRefObject<HTMLDivElement | null>;
}

/**
 * Preview of a single element: a stationary diagram map (see
 * {@link useDiagramPreviewMap}) centered on the element at the primary map's
 * maximum zoom.
 */
export const useElementDiagramPreview = (
  center: Point | undefined,
): UseElementDiagramPreviewResult => {
  const { mapInstance } = useMapInstance();
  const view = useOlElementPreviewView(center, mapInstance);
  const { targetRef } = useDiagramPreviewMap(view);

  return { targetRef };
};
